import React, { useEffect, useState, useRef } from "react";
import LocationOnRoundedIcon from '@mui/icons-material/LocationOnRounded';
import NavigationRoundedIcon from '@mui/icons-material/NavigationRounded';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import LayersOutlinedIcon from '@mui/icons-material/LayersOutlined';
import GpsFixedRoundedIcon from '@mui/icons-material/GpsFixedRounded';
import axiosInstance from "../../api/axiosInstance";
import "../changeMap/changeMap.scss";

const styles = [
    { label: 'Verkehrslage', img: 'map_traffic.png', value: 'mapbox://styles/mapbox/traffic-day-v2' },
    { label: 'Orte', img: 'map_default.png', value: 'mapbox://styles/mapbox/streets-v12' },
    { label: 'Satellit', img: 'map_satellite.png', value: 'mapbox://styles/mapbox/standard-satellite' },
];

const ChangeMap = ({ mapSettings, setMapSettings, category, setCategory, flyToUserLocation, isLocation }) => {
    const [isLoading, setLoading] = useState(true);
    const [categories, setCategories] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);
    const currentIndex = styles.findIndex(style => style.value === mapSettings.style);
    const nextIndex = (currentIndex + 1) % styles.length;
    const nextStyle = styles[nextIndex];

    const buttonRef = useRef(null);
    const modalRef = useRef(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [categoriesRes] = await Promise.all([
                    axiosInstance.get(`categories`),
                ]);

                setCategories(categoriesRes.data);
                setLoading(false);
            } catch (err) {
                console.error(err);
            }
        };
        fetchData();
    }, []);

    // Automatisch localStorage updaten, wenn mapSettings sich ändert
    const handleChangeMapSettings = (updates) => {
        setMapSettings(prev => ({ ...prev, ...updates }));
    };

    useEffect(() => {
        localStorage.setItem("mapSettings", JSON.stringify(mapSettings));
    }, [mapSettings]);

    // Automatisch localStorage updaten, wenn mapCategories sich ändert
    const handleChangeCategory = (categoryId) => {
        setCategory(prev =>
            prev.includes(categoryId)
                ? prev.filter(id => id !== categoryId)
                : [...prev, categoryId]
        );
    };

    useEffect(() => {
        localStorage.setItem("mapCategories", JSON.stringify(category));
    }, [category]);

    const handleOpenModal = () => {
        setModalOpen(current => !current);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                modalRef.current &&
                !modalRef.current.contains(event.target) &&
                buttonRef.current &&
                !buttonRef.current.contains(event.target)
            ) {
                setModalOpen(false);
            }
        };

        if (modalOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [modalOpen]);

    if (isLoading) return (<div />)

    return (
        <div className="changeMap">
            <div className="filterSwitch" title="Filter" onClick={handleOpenModal} ref={buttonRef}>
                <FilterAltOutlinedIcon />
            </div>
            <div className="filterSwitch" title={`Wechsle zu: ${nextStyle.label}`} onClick={() => handleChangeMapSettings({ style: nextStyle.value })}>
                <LayersOutlinedIcon />
            </div>
            <div className="filterSwitch" disabled={!isLocation && true} title="Aktuelle Position" onClick={flyToUserLocation}>
                <GpsFixedRoundedIcon />
            </div>
            {modalOpen &&
                <div className="filterModal" ref={modalRef}>
                    <div className="modalContent">
                        <h4>Filter</h4>
                        <span>Kategorien wählen</span>
                        {categories
                            .filter(category => category.layer === 1)
                            .map((categories) => (
                                <div className="group" key={categories.id}>
                                    <button className="toggle" onClick={() => handleChangeCategory(categories.id)}>
                                        <NavigationRoundedIcon className={category.includes(categories.id) && "tracker"} />
                                        <span>{categories.name}</span>
                                    </button>
                                </div>
                            ))}
                        <span>ERGO Schnittstelle</span>
                        <div className="group">
                            <button className="toggle" onClick={() => handleChangeCategory(0)}>
                                <LocationOnRoundedIcon className={category.includes(0) && "constructionSites"} />
                                <span>Baustellen</span>
                            </button>
                        </div>
                    </div>
                </div>
            }
        </div>
    );
};

export default ChangeMap;